import React from 'react';
import { TreatmentAreasSection } from '../components/TreatmentAreasSection';
export function TreatmentAreasPage() {
  return <div className="pt-28" data-id="element-501">
      <TreatmentAreasSection data-id="element-502" />
    </div>;
}